import { useQuery } from '@tanstack/react-query';
import * as Api from '../api';
import type { AnalyticsParams, ItemAnalysisResponse } from '../types';

interface IProps {
  orgId?: string;
  testId?: string;
  params: AnalyticsParams;
  enabled?: boolean;
}

const useItemAnalysis = ({ orgId, testId, params, enabled = true }: IProps) =>
  useQuery<ItemAnalysisResponse>({
    queryKey: ['analytics', 'items', orgId, testId, params],
    queryFn: async () => {
      const { data } = await Api.GetItemAnalysis(testId as string, params);
      return data;
    },
    enabled: !!orgId && !!testId && enabled,
    staleTime: 30_000,
  });

export default useItemAnalysis;
